import { format, getTime, formatDistanceToNow } from 'date-fns';
import moment from 'moment-timezone';

let regionalFormats = { dateFormat: 'DD/MM/YYYY', timeFormat: 'HH:mm', timezone: moment.tz.guess() };

export function setDateTimeFormats(settings = {}) {
  regionalFormats = { ...regionalFormats, ...settings };
}

export function getDateTimePickerConfig(settings = regionalFormats) {
  const resolvedSettings = settings ?? regionalFormats;
  const dateFormat = resolvedSettings.dateTimeFormats?.date || 'dd/MM/yyyy';
  const timeFormat = resolvedSettings.dateTimeFormats?.time || 'HH:mm';
  return {
    ampm: resolvedSettings.dateTimeFormats?.ampm ?? false,
    formats: {
      keyboardDate: dateFormat,
      keyboardDateTime: `${dateFormat} ${timeFormat}`,
      keyboardDateTime12h: `${dateFormat} ${timeFormat}`,
      keyboardDateTime24h: `${dateFormat} ${timeFormat}`,
      fullTime: timeFormat,
      fullTime12h: timeFormat,
      fullTime24h: timeFormat,
    },
  };
}

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  if (!newFormat) return date ? moment(date).tz(regionalFormats.timezone).format(regionalFormats.dateFormat) : '';
  return date ? format(new Date(date), newFormat) : '';
}

// For calendar dates stored as UTC boundaries (e.g. a billing period of
// 1st 00:00 UTC to last day 23:59:59 UTC, or a date-only field saved as UTC
// midnight): shown in UTC so the franchise timezone cannot shift the day.
export function fCalendarDate(date) {
  return date ? moment.utc(date).format(regionalFormats.dateFormat) : '';
}

export function fDateTime(date, newFormat) {
  if (!newFormat) return date ? moment(date).tz(regionalFormats.timezone).format(`${regionalFormats.dateFormat} ${regionalFormats.timeFormat}`) : '';
  return date ? format(new Date(date), newFormat) : '';
}

export function fTime(date, newFormat) {
  if (!newFormat) return date ? moment(date).tz(regionalFormats.timezone).format(regionalFormats.timeFormat) : '';
  return date ? format(new Date(date), newFormat) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}


export function fCurrentDateTime() {
  return format(new Date(), "yyyy-MM-dd HH:mm:ss.SSS");
}
export function formatHourMinute(date) {
  let dateObj = new Date(date)
  const hour = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  return `${hour}:${minutes}`;
}
